/**
 * Created by Administrador on 11/11/2016.
 */
(function(){
    'use strict';

    var inputMask = {
        template: '',
        controller: inputMaskController,
        controllerAs: 'vm',
        bindings: {
            masked: "@"
        }
    };

    angular
        .module('completeAir')
        .component('inputMask', inputMask);

    inputMaskController.$inject = ['$element'];

    function inputMaskController($element){
        var vm = this;
        var eleJQParent = $element.parent();
        var eleJQInput = eleJQParent.find('.form-control');

        vm.$onInit = function () {
            vm.$postLink();
        }

        vm.$postLink = function() {
            eleJQInput.mask(vm.masked);
        }
    }
})();
